import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-support-icon',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './support-icon.component.html',
  styleUrls: ['./support-icon.component.scss']
})
export class SupportIconComponent {
  isLoginPage = false;


  constructor(private router: Router) {
    this.router.events.subscribe(() => {
      this.isLoginPage = this.router.url.includes('/login');
    });
  }

  onSupportClick() {
    if (this.router.url === '/support/new') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/support/new']);
      });
    } else {
      this.router.navigate(['/support/new']);
    }
  }

}
